import {ChangeDetectorRef, Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {StateConfigService} from "../../../services/state/state-config.service";
import {AuthControllerService, ProjectFileControllerService, Task} from "../../../api";
import {TaskDetailsService} from "../../../services/tasks/task-details.service";
import {HttpClient, HttpEventType, HttpRequest, HttpResponse} from "@angular/common/http";
import {NumberToLphPipe} from "../../../pipes/lphToNumber.pipe";
import {BimIdModule} from "@buildinginformationcloud/bim-id";

@Component({
  selector: 'app-bim-id',
  templateUrl: './bim-id.component.html',
  styleUrls: ['./bim-id.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BimIdModule
  ]
})
export class BimIdComponent implements OnInit {
  private stateConfigService = inject(StateConfigService);
  private authControllerService = inject(AuthControllerService);
  private cdr = inject(ChangeDetectorRef);
  private taskDetailService = inject(TaskDetailsService);
  private fileControllerService = inject(ProjectFileControllerService);
  private http = inject(HttpClient);


  user: any
  uploadingDocuments: Map<string, number> = new Map<string, number>();

  numberToLph = new NumberToLphPipe()

  ngOnInit() {
    this.authControllerService.profile().subscribe((user)=>{
      this.user = user
      this.cdr.detectChanges()
      }
    )
  }

  getProject(){
    return this.stateConfigService.getProject()
  }

  createTask(data: any){
    //data: data.documentId, data.doc, data.title
    let task = {
      markup:{topic:{title:data.title}}
    }
    this.taskDetailService.setOpenedTask(task as Task);
  }

  addToFiles(data: any){
    //data: data.documentId, data.doc, data.name, data.lph, data.link
    let leistung = data.lph-1
    this.http.get(data.link, { responseType: 'blob' }).subscribe((blob: any) => {
      // TODO: add addFile Method in ProjectFileControllerService
      // this.fileControllerService.addFile(this.stateConfigService.getProjectId(), ProjectFile.FolderEnum.PLANUNGUNDBIM, this.numberToLph.transform(leistung.toString()), data.name, blob.size).subscribe(s => {
      //   console.log('added file', s.fileId)
      //   this.uploadFileUsingPresignedUrlWithProgress(s.string!, blob, s.fileId!, data.name);
      // })
    });
  }

  uploadFileUsingPresignedUrlWithProgress(url: string, file: File, fileId: string, fileName: string): void {
    const req = new HttpRequest('PUT', url, file, {
      reportProgress: true,
    });

    this.http.request(req).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          const percentDone = Math.round((100 * event.loaded) / event.total!);
          this.uploadingDocuments.set(fileName, percentDone);
        } else if (event instanceof HttpResponse) {
          this.uploadingDocuments.delete(fileName);
          this.fileControllerService.classify(this.stateConfigService.getProjectId(), fileId).subscribe(data => {
          });
        }
      });
  }


}
